import styled from 'styled-components';

export const DatePickerFieldWrapper = styled.div`
  flex: 2;
`;
